$(document).ready(function() {
    // alert('xxx')
    var slider = $("#testimonials-slider");
    slider.slick({
        centerMode: true,
        slidesToShow: 1,
        arrows: true,
        centerPadding: '107px',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    centerPadding: '0',
                }
            },
        ]
    })
});